<template>
  <InformativeModal
    :isVisible="showModal"
    :title="recovery.message_title"
    :description="recovery.message_text"
    :buttonText="$t('general.continue')"
    buttonTextCustomClass="gc-font-button rounded-gc-sm text-center !bg-btn !text-text-btn md:hover:!bg-btn-hover md:hover:!text-text-btn-hover border border-btn-border md:hover:border-btn-border-hover !font-secondary w-auto h-auto mr-2 px-6"
    type="shoppingRecovery"
    @update:isVisible="handleModalClose" />
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import InformativeModal from '@/components/customComponents/InformativeModal.vue';
import { useShoppingRecoveryStore } from '@/stores/shoppingRecovery.store.js';

const store = useShoppingRecoveryStore();
const { setupRecoveryBehavior, cleanupRecoveryBehavior } = store;
const { shouldShowRecovery, isInitialized } = storeToRefs(store);
const props = defineProps({
  recovery: {
    type: Object,
    required: true,
  },
});

const showModal = ref(false);

watch(
  () => shouldShowRecovery.value.get(props.recovery.trigger),
  (shouldShow) => {
    if (shouldShow) {
      showModal.value = true;
    }
  },
);

watch(isInitialized, (newValue) => {
  if (newValue) {
    setupRecoveryBehavior(props.recovery);
  }
});

const handleModalClose = () => {
  showModal.value = false;
  cleanupRecoveryBehavior(props.recovery);
};

onMounted(() => {
  if (isInitialized.value) {
    setupRecoveryBehavior(props.recovery);
  }
});

onUnmounted(() => {
  cleanupRecoveryBehavior(props.recovery);
});
</script>
